import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { postData } from "../../services/generalService";
import { PostReversalBillResponseObj } from "../../utils/types";

const initialState: PostReversalBillResponseObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const postBillReversalTransaction = createAsyncThunk(
  "loans/postBillReversalTransaction",
  async (formData: { url: string; postsData: {} }, thunkAPI) => {
    const { url, postsData } = formData;
    try {
      const data = await postData(url, postsData, true);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const postBillReversalTransactionSlice = createSlice({
  name: "postBillReversalTransaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postBillReversalTransaction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postBillReversalTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(postBillReversalTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default postBillReversalTransactionSlice.reducer;
